import React, { useState, useRef, useEffect } from "react";
import { useField } from "@unform/core";

import { MdInsertPhoto } from "react-icons/md";
import { toast } from "react-toastify";

import { Container, DefaultAvatar } from "./styles";
import api from "../../../services/api";

export default function AvatarInputGd({ name, ...rest }) {
  const ref = useRef(null);
  const { fieldName, registerField, defaultValue, error } = useField(name);

  const [fileId, setFileId] = useState(defaultValue && defaultValue.id);
  const [preview, setPreview] = useState(defaultValue && defaultValue.url);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: ref.current,
      path: "dataset.fileid",
      clearValue() {
        ref.value = "";
        setPreview(null);
      },
    });
  }, [fieldName, registerField]);

  useEffect(() => {
    if (defaultValue) {
      setPreview(defaultValue.url);
      setFileId(defaultValue.id);
    }
  }, [defaultValue]);

  async function handleChange(e) {
    try {
      const data = new FormData();
      const token = localStorage.getItem("@clube:token");
      data.append("file", e.target.files[0]);

      if (fileId) {
        await api.delete(`store/files/${defaultValue.id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }

      const response = await api.post("store/files", data, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const { id, url } = response.data;

      setFileId(id);
      setPreview(url);
    } catch (err) {
      toast.error(error.response.data.error);
    }
  }

  return (
    <Container>
      <label htmlFor="avatar">
        {preview ? (
          <img
            src={preview}
            style={{ height: 200, width: 300 }}
            alt="User Avatar"
          />
        ) : (
          <DefaultAvatar>
            <MdInsertPhoto size={45} color="#ddd" />
            <span>Adicionar Logo</span>
          </DefaultAvatar>
        )}

        <input
          type="file"
          id="avatar"
          accept="image/*"
          data-fileid={fileId}
          onChange={handleChange}
          ref={ref}
          {...rest}
        />
      </label>
    </Container>
  );
}
